import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';

/**
 * Section d'accueil « Nos agences » : contenu crawlable ciblant les requêtes
 * « agence d'automatisation IA France / Tunisie » + maillage interne vers les
 * deux landing pages géolocalisées.
 */
const zones = [
  {
    title: "Agence d'automatisation IA en France",
    text: "Paris et toute la France : agents IA, chatbots et workflows n8n conformes RGPD pour PME françaises. Audit gratuit, déploiement en 2 à 4 semaines.",
    link: '/agence-automatisation-ia-france',
    label: 'Découvrir notre agence en France',
  },
  {
    title: "Agence d'automatisation IA en Tunisie",
    text: "Depuis La Marsa (Grand Tunis) : chatbots WhatsApp, agents IA et automatisations pour entreprises tunisiennes. Qualité européenne, tarifs locaux.",
    link: '/agence-automatisation-ia-tunisie',
    label: 'Découvrir notre agence en Tunisie',
  },
];

const GeoSeoSection = () => (
  <section id="zones" className="py-16 md:py-20">
    <div className="container mx-auto max-w-5xl px-6">
      <h2 className="mb-4 text-3xl font-bold tracking-tight md:text-4xl">
        Une agence d'automatisation IA en France et en Tunisie
      </h2>
      <p className="mb-10 max-w-3xl text-muted-foreground">
        FastTask accompagne les PME des deux rives de la Méditerranée : une présence à Paris
        pour les entreprises françaises, une équipe à La Marsa pour les entreprises
        tunisiennes. Mêmes outils, mêmes standards, même exigence de résultats.
      </p>
      <div className="grid gap-6 md:grid-cols-2">
        {zones.map((zone) => (
          <div key={zone.link} className="flex flex-col rounded-2xl border border-border p-6">
            <div className="mb-3 flex items-center gap-2">
              <MapPin className="h-5 w-5 text-primary" aria-hidden="true" />
              <h3 className="text-lg font-semibold">{zone.title}</h3>
            </div>
            <p className="mb-4 flex-1 text-sm leading-relaxed text-muted-foreground">{zone.text}</p>
            <Link
              to={zone.link}
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
            >
              {zone.label}
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default GeoSeoSection;
